import React from 'react';
import Nav from '../Nav/Nav'
import './sidebar.css';

export default function Sidebar() {
    return (
        <aside className="app-sidebar">
            <Nav />
        </aside>
    )

}
